export interface AiPromptBoxInputField {
  hideScrollbar: boolean;
}
/** How long the daily-limit message stays visible after a blocked submit attempt. */
export const DAILY_LIMIT_ERROR_VISIBLE_MS = 3000;
